import LoadingDots from "../../atoms/Loaders/BouncingDots";
import preparingImg from "../../../assets/images/preparing_tire.png";

export default function GettingReadyPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-blue-100">
      <div className="m-6 w-full max-w-xl overflow-hidden rounded-2xl bg-white shadow-xl border border-blue-100">
        <div className="px-6 py-10 sm:p-8 text-center animate-fadeIn">
          <img
            className="max-h-28 mx-auto mb-6"
            alt="Tire character preparing"
            src={preparingImg}
          />

          <h1 className="font-serif text-3xl font-bold text-gray-800 mb-2">
            Getting things ready for you...
          </h1>

          <LoadingDots />

          <p className="font-sans text-gray-500 mt-6 max-w-md mx-auto">
            We're tuning up your experience — loading preferences... Just a
            moment!
          </p>
        </div>
      </div>
    </div>
  );
}
